import React from 'react';
import AboutHero from './AboutHero';
import './LegalDocument.css';

const navigateTo = (path) => {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

const CompanyDetails = ({ labels }) => (
  <div className="legal-company-meta">
    <p><strong>{labels.company}:</strong> RECENTINSPIRATION</p>
    <p><strong>{labels.tradeName}:</strong> SMART TELECOM STORE</p>
    <p><strong>{labels.kvk}:</strong> 42091099</p>
    <p><strong>{labels.vat}:</strong> NL005488135B34</p>
    <p><strong>{labels.address}:</strong> Zuylesteinstraat 21, 1333 XZ Almere, The Netherlands</p>
    <p><strong>{labels.telephone}:</strong> <a href="tel:+31687748358">+31 687748358</a></p>
    <p><strong>{labels.email}:</strong> <a href="mailto:smarttelecom.nl@gmail.com">smarttelecom.nl@gmail.com</a></p>
    <p><strong>{labels.website}:</strong> <a href="https://smarttelecomstore.com" target="_blank" rel="noopener noreferrer">https://smarttelecomstore.com</a></p>
  </div>
);

const renderParagraph = (para, idx) => {
  if (para && typeof para === 'object' && para.label) {
    return (
      <p key={idx}>
        {para.before}
        <a
          href="/privacy-statement"
          onClick={(e) => {
            e.preventDefault();
            navigateTo('/privacy-statement');
          }}
        >
          {para.label}
        </a>
        {para.after}
      </p>
    );
  }
  return <p key={idx}>{para}</p>;
};

const LegalDocument = ({ heading, subtitle, sections, companyLabels }) => (
  <div className="legal-page-wrapper">
    <AboutHero />
    <div className="legal-content-container">
      <div className="legal-intro-card">
        <CompanyDetails labels={companyLabels} />
      </div>
      {sections.map((section) => (
        <article className="legal-section-card" key={section.num}>
          <h3>{section.num}. {section.title}</h3>
          {(section.paragraphs || []).map((para, idx) => renderParagraph(para, idx))}
          {section.privacyLink ? renderParagraph(section.privacyLink, 'privacy-link') : null}
          {section.list ? (
            <ul>
              {section.list.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          ) : null}
          {(section.afterList || []).map((para, idx) => (
            <p key={`after-${idx}`}>{para}</p>
          ))}
        </article>
      ))}
    </div>
  </div>
);

export default LegalDocument;
